import { Injectable } from "@angular/core";
import { LiveUpdateConnector } from "../models/live-update-connector.model";
import { LiveUpdateConnections } from "./live-update-connections.service";

@Injectable()
export abstract class LiveUpdateBaseService {
    connector: LiveUpdateConnector;
    connectionId: string;
    subscriptionId: string;
    endpoint: string;

    constructor(endpoint: string, private liveUpdateConnections: LiveUpdateConnections) {
        this.endpoint = endpoint;
        this.connector = this.liveUpdateConnections.getConnector(endpoint);
        
        this.subscriptionId = '_' + Math.random().toString(36).substr(2, 9);

        this.connector.connection$.subscribe(hub => this.connectionId = hub.connectionId);
    }

    ngOnDestroy() {
        this.connector.killSubscriptions(this.subscriptionId);
    }
}